/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Contract_No_PrepaidInputs */



/**
* | output |
* | --- |
* | "Seats only — this agreement includes no prepaid usage budget." |
*
* @param {Partner_Org_Contract_No_PrepaidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_no_prepaid = /** @type {((inputs?: Partner_Org_Contract_No_PrepaidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_No_PrepaidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur Plätze — diese Vereinbarung enthält kein vorausbezahltes Nutzungsbudget.")
	return /** @type {LocalizedString} */ ("Seats only — this agreement includes no prepaid usage budget.")
});